import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {};
export const section = createSlice({
  name: "section",
  initialState,
  reducers: {
    addSection: (state, action) => {
      return action.payload;
    },

    deleteSection: (state, action) => {
      return {};
    },
  },
});
export const { addSection, deleteSection } = section.actions;
export default section.reducer;
